import React from 'react';
import tpl from '../templates/quick-cash-business';
import BaseQuickCashView from '../../../../Credit/views/BaseQuickCashView';

export default class extends BaseQuickCashView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            tab: 'calculator'
        };
    }

    static displayName = 'Business.Views.QuickCashBusiness';
}
